// ¿Atlas está abierto dentro del navegador de otra app (Instagram, Facebook, …)?
//
// LA regla de la app para eso: la usan el aviso de Google en el registro
// (`AvisoGoogleEnApp`), el aviso de Tiendanube cuando la ventana no se abre y el del retorno
// de Google trabado (los dos por `navegadorDentroDeApp`). Antes eran dos detectores con
// listas distintas (ADR-2026-10-20-google-avisa-en-instagram-sin-frenar).
//
// Estricto A PROPÓSITO, y distinto de `isInAppBrowser()` (el de las descargas): ese toma
// cualquier navegador desconocido de iPhone como embebido, y para estos avisos eso le
// hablaría de Instagram a quien usa Edge, Opera o DuckDuckGo. Solo cuenta lo que se
// reconoce: las apps por nombre y el webview genérico de Android (`; wv)`). Ante la duda,
// no es embebido.
//
// Puro y sin imports, para que cualquiera lo use y lo testee sin arrastrar nada.

/** Desde qué app. `null` = un navegador embebido de Android que no identificamos. */
export type AppEmbebida = 'Instagram' | 'Facebook' | 'Messenger' | 'TikTok' | 'LinkedIn' | 'LINE' | null;

export interface NavegadorEmbebido {
  app: AppEmbebida;
  android: boolean;
}

export function navegadorEmbebido(ua: string | null | undefined): NavegadorEmbebido | null {
  const u = ua ?? '';
  if (!u) return null;
  const android = /Android/i.test(u);
  // Messenger antes que Facebook: su user-agent también trae las marcas de Facebook.
  if (/MessengerForiOS|FBAN\/Messenger|FB_IAB\/Orca|MessengerLite/i.test(u)) return { app: 'Messenger', android };
  if (/Instagram/i.test(u)) return { app: 'Instagram', android };
  if (/FBAN|FBAV|FB_IAB|FB4A|FBIOS/.test(u)) return { app: 'Facebook', android };
  if (/musical_ly|BytedanceWebview|TikTok|trill_/i.test(u)) return { app: 'TikTok', android };
  if (/LinkedInApp/i.test(u)) return { app: 'LinkedIn', android };
  if (/\bLine\//.test(u)) return { app: 'LINE', android };
  if (android && /; wv\)/.test(u)) return { app: null, android: true };
  return null;
}
